import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./TermsConditions.css"; // optional – you can add custom styles if needed

const TermsConditions = () => {
  return (
    <React.Fragment>
      <Header variant="light" />
      <div className="terms-conditions">
        <Helmet>
          <title>Terms & Conditions - Panmitra Online Services</title>
          <meta
            name="description"
            content="Terms and conditions for using Panmitra's PAN card, recharge, bill payment, insurance, and API services. Please read carefully before using our platform."
          />
        </Helmet>

        <div className="body-overlay"></div>

        <main>
          {/*===== HERO AREA STARTS =======*/}
          <div
            className="about-header-area"
            style={{
              backgroundImage: "url(assets/img/bg/inner-header.png)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-7 m-auto">
                  <div className="about-inner-header heading9 text-center">
                    <h1>Terms & Conditions</h1>
                    <a href="/">
                      Home <i className="fa-solid fa-angle-right" />{" "}
                      <span>Terms & Conditions</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ===== Terms Content inside a Card ===== */}
          <div className="container py-5">
            <div className="terms-card p-5 bg-white rounded shadow-sm">
              <h1 className="fw-bold text-center mb-4">Terms & Conditions</h1>
              <p className="text-center text-muted effective-date">
                Last Updated: 01.03.2026
              </p>

              <section className="mb-5">
                <h2>1. Introduction & Acceptance</h2>
                <p>
                  These Terms & Conditions ("Terms") constitute a legally
                  binding agreement between you ("User", "Agent", "Distributor",
                  "Customer") and{" "}
                  <strong>PANMITRA ONLINE SERVICE PRIVATE LIMITED</strong>,
                  having its registered office at Belagavi, Karnataka - 590015,
                  India. By accessing or using our website, mobile application,
                  or any of our services including but not limited to PAN card
                  services, mobile/DTH recharge, utility bill payments, motor
                  insurance (POSP), API solutions, and agent/distributor
                  programs, you acknowledge that you have read, understood, and
                  unconditionally agree to be bound by these Terms.
                </p>
                <p>
                  If you do not agree with any part of these Terms, you must
                  immediately discontinue access to our platform and refrain
                  from using any of our services.
                </p>
              </section>

              <section className="mb-5">
                <h2>2. Definitions</h2>
                <p>In these Terms, unless the context otherwise requires:</p>
                <ul>
                  <li>
                    <strong>"Company", "We", "Us", "Our"</strong> means PANMITRA
                    ONLINE SERVICE PRIVATE LIMITED.
                  </li>
                  <li>
                    <strong>"Platform"</strong> means the website
                    instantpanmitra.com, mobile applications, and any associated
                    services.
                  </li>
                  <li>
                    <strong>"Services"</strong> means all products and services
                    offered by the Company, including PAN card services,
                    recharges, bill payments, insurance, APIs, and agent
                    programs.
                  </li>
                  <li>
                    <strong>"User", "You", "Your"</strong> means any individual
                    or entity accessing or using the Platform.
                  </li>
                  <li>
                    <strong>"Agent"</strong> means a registered user who
                    provides Services to end customers using the Platform.
                  </li>
                  <li>
                    <strong>"Transaction"</strong> means any financial or
                    non-financial activity performed through the Platform.
                  </li>
                </ul>
              </section>

              <section className="mb-5">
                <h2>3. Eligibility & Registration</h2>
                <p>
                  3.1 Our Services are available only to individuals who are at
                  least 18 years of age and to business entities legally capable
                  of entering into binding contracts. By using our Platform, you
                  represent and warrant that you meet these eligibility
                  requirements.
                </p>
                <p>
                  3.2 To access certain Services, you must register for an
                  account and provide accurate, complete, and current
                  information. You are solely responsible for maintaining the
                  confidentiality of your login credentials and for all
                  activities that occur under your account.
                </p>
                <p>
                  3.3 The Company reserves the right to reject any registration
                  application or suspend/terminate any existing account at its
                  sole discretion, without assigning any reason or prior notice.
                </p>
              </section>

              <section className="mb-5">
                <h2>4. Scope of Services</h2>
                <p>
                  The Company provides a digital platform for the following
                  Services, which may be modified, suspended, or discontinued at
                  any time without prior notice:
                </p>
                <ul>
                  <li>
                    <strong>PAN Card Services:</strong> Application, processing,
                    and tracking of PAN cards through authorized government
                    portals.
                  </li>
                  <li>
                    <strong>Mobile & DTH Recharge:</strong> Prepaid, postpaid,
                    and DTH recharge for various operators.
                  </li>
                  <li>
                    <strong>Utility Bill Payments:</strong> Payment of
                    electricity, water, gas, and broadband bills through BBPS
                    and other channels.
                  </li>
                  <li>
                    <strong>Motor Insurance (POSP):</strong> Facilitation of
                    two-wheeler and four-wheeler insurance policies.
                  </li>
                  <li>
                    <strong>API Solutions:</strong> Access to REST APIs for
                    integrating Services into third-party applications.
                  </li>
                  <li>
                    <strong>Agent / Distributor Programs:</strong> Business
                    opportunities for registered agents and distributors.
                  </li>
                </ul>
                <p>
                  The Company acts only as a facilitator/platform provider and
                  is not responsible for the final delivery of services by
                  third-party providers (government agencies, telecom operators,
                  utility companies, insurance companies, etc.).
                </p>
              </section>

              <section className="mb-5">
                <h2>5. User Obligations & Responsibilities</h2>
                <p>By using our Platform, you expressly agree to:</p>
                <ul>
                  <li>
                    5.1 Provide true, accurate, and complete information during
                    registration and for each Transaction.
                  </li>
                  <li>
                    5.2 Verify all details (PAN applicant information, mobile
                    number, bill amount, policy details, etc.) before confirming
                    any Transaction.
                  </li>
                  <li>
                    5.3 Maintain strict confidentiality of your account
                    credentials and immediately notify us of any unauthorized
                    use.
                  </li>
                  <li>
                    5.4 Use the Platform only for lawful purposes and in
                    compliance with all applicable laws, rules, and regulations.
                  </li>
                  <li>
                    5.5 Not engage in any fraudulent, misleading, or illegal
                    activities.
                  </li>
                  <li>
                    5.6 Not attempt to reverse engineer, copy, or misuse any
                    part of the Platform or its content.
                  </li>
                  <li>
                    5.7 Not use bots, scrapers, or automated means to access the
                    Platform without written consent.
                  </li>
                  <li>
                    5.8 Indemnify and hold the Company harmless against any
                    claims, losses, or damages arising from your breach of these
                    Terms or misuse of the Platform.
                  </li>
                </ul>
              </section>

              <section className="mb-5">
                <h2>6. Fees, Charges & Payments</h2>
                <p>
                  6.1 The Company may charge convenience fees, service charges,
                  commissions, or other fees for Transactions, which will be
                  clearly displayed before you complete a Transaction.
                </p>
                <p>
                  6.2 All payments are processed through third-party payment
                  gateways. The Company is not responsible for any delays,
                  failures, or issues arising from such gateways.
                </p>
                <p>
                  6.3 You are solely responsible for all applicable taxes,
                  duties, or levies on Transactions.
                </p>
                <p>
                  6.4 The Company reserves the absolute right to revise its fee
                  structure at any time, with updates effective immediately upon
                  posting on the Platform. Continued use of Services constitutes
                  acceptance of revised fees.
                </p>
              </section>

              <section className="mb-5">
                <h2>7. Refunds & Cancellations</h2>
                <p>
                  7.1 Transactions once successfully processed are generally
                  non-refundable and non-cancellable.
                </p>
                <p>
                  7.2 In case of a failed Transaction where the amount has been
                  debited from your account, the Company will initiate a refund
                  through the original payment mode. However, the Company does
                  not guarantee the timeline for such refunds, which are subject
                  to bank processing times (typically 5-7 working days).
                </p>
                <p>
                  7.3 For PAN card applications, if the application is rejected
                  by the government authority due to incorrect information
                  provided by you, no refund shall be applicable.
                </p>
                <p>
                  7.4 Any refunds are at the sole discretion of the Company and
                  shall be governed by our Refund Policy, which forms part of
                  these Terms.
                </p>
              </section>

              <section className="mb-5">
                <h2>8. Limitation of Liability</h2>
                <p>
                  8.1 To the maximum extent permitted by law, the Company, its
                  directors, employees, or affiliates shall not be liable for
                  any indirect, incidental, special, consequential, or punitive
                  damages arising out of or related to your use of the Platform
                  or Services.
                </p>
                <p>
                  8.2 The Company's total liability, whether in contract, tort,
                  or otherwise, shall not exceed the amount paid by you for the
                  specific Transaction that gave rise to the claim.
                </p>
                <p>8.3 The Company shall not be liable for:</p>
                <ul>
                  <li>
                    Any delays, failures, or errors caused by third-party
                    service providers (banks, government agencies, telecom
                    operators, utility companies, etc.).
                  </li>
                  <li>Any loss of data, profits, or business opportunities.</li>
                  <li>
                    Any unauthorized access to your account due to your
                    negligence.
                  </li>
                  <li>
                    Any force majeure events including but not limited to
                    natural disasters, strikes, internet failures, or government
                    actions.
                  </li>
                </ul>
              </section>

              <section className="mb-5">
                <h2>9. Disclaimers</h2>
                <p>
                  9.1 The Platform and Services are provided on an "as is" and
                  "as available" basis without warranties of any kind, either
                  express or implied, including but not limited to warranties of
                  merchantability, fitness for a particular purpose, or
                  non-infringement.
                </p>
                <p>9.2 The Company does not warrant that:</p>
                <ul>
                  <li>
                    The Platform will be uninterrupted, timely, secure, or
                    error-free.
                  </li>
                  <li>
                    The results obtained from using the Services will be
                    accurate or reliable.
                  </li>
                  <li>Any errors in the Platform will be corrected.</li>
                </ul>
                <p>
                  9.3 The Company is not responsible for the accuracy,
                  completeness, or legality of information provided by third
                  parties, including but not limited to PAN application status,
                  recharge confirmations, bill payment updates, or insurance
                  policy details.
                </p>
              </section>

              <section className="mb-5">
                <h2>10. Intellectual Property</h2>
                <p>
                  10.1 All content, logos, trademarks, service marks, software,
                  databases, and technology on the Platform are the exclusive
                  property of the Company or its licensors.
                </p>
                <p>
                  10.2 You are granted a limited, non-exclusive,
                  non-transferable, revocable license to access and use the
                  Platform for personal or business purposes in accordance with
                  these Terms.
                </p>
                <p>
                  10.3 Any unauthorized use, reproduction, modification,
                  distribution, or republication of any content from the
                  Platform is strictly prohibited and may result in legal
                  action.
                </p>
              </section>

              <section className="mb-5">
                <h2>11. Termination</h2>
                <p>
                  11.1 The Company may, at its sole discretion, suspend or
                  terminate your access to the Platform immediately, without
                  prior notice or liability, for any reason whatsoever,
                  including but not limited to:
                </p>
                <ul>
                  <li>Breach of these Terms.</li>
                  <li>Fraudulent or illegal activities.</li>
                  <li>Inactivity for an extended period.</li>
                  <li>Technical or security reasons.</li>
                </ul>
                <p>
                  11.2 Upon termination, your right to use the Platform ceases
                  immediately. All provisions of these Terms which by their
                  nature should survive termination shall survive, including
                  ownership provisions, warranty disclaimers, indemnity, and
                  limitations of liability.
                </p>
              </section>

              <section className="mb-5">
                <h2>12. Indemnification</h2>
                <p>
                  You agree to indemnify, defend, and hold harmless the Company,
                  its directors, employees, and affiliates from and against any
                  and all claims, damages, losses, liabilities, costs, and
                  expenses (including reasonable legal fees) arising out of or
                  related to:
                </p>
                <ul>
                  <li>Your use or misuse of the Platform or Services.</li>
                  <li>Your breach of these Terms.</li>
                  <li>
                    Your violation of any applicable law or third-party rights.
                  </li>
                  <li>Any content or information provided by you.</li>
                </ul>
              </section>

              <section className="mb-5">
                <h2>13. Amendments to Terms</h2>
                <p>
                  The Company reserves the unconditional right to modify,
                  update, or replace these Terms at any time without prior
                  notice. Changes will be effective immediately upon posting on
                  the Platform. Your continued use of the Platform after any
                  such changes constitutes your acceptance of the revised Terms.
                  It is your responsibility to review these Terms periodically.
                </p>
              </section>

              <section className="mb-5">
                <h2>14. Governing Law & Dispute Resolution</h2>
                <p>
                  14.1 These Terms shall be governed by and construed in
                  accordance with the laws of India.
                </p>
                <p>
                  14.2 Any dispute, controversy, or claim arising out of or
                  relating to these Terms or the use of the Platform shall first
                  be attempted to be resolved through good-faith negotiations.
                </p>
                <p>
                  14.3 If the dispute cannot be resolved within 30 days, it
                  shall be referred to binding arbitration in accordance with
                  the Arbitration and Conciliation Act, 1996. The arbitration
                  shall be conducted in Belagavi, Karnataka, in the English
                  language, by a sole arbitrator appointed by the Company. The
                  arbitral award shall be final and binding on both parties.
                </p>
                <p>
                  14.4 Subject to the arbitration clause, the courts in
                  Belagavi, Karnataka shall have exclusive jurisdiction over any
                  matters arising under these Terms.
                </p>
              </section>

              <section className="mb-5">
                <h2>15. Waiver & Severability</h2>
                <p>
                  15.1 The failure of the Company to enforce any right or
                  provision of these Terms shall not constitute a waiver of such
                  right or provision.
                </p>
                <p>
                  15.2 If any provision of these Terms is found to be invalid or
                  unenforceable by a court of competent jurisdiction, the
                  remaining provisions shall remain in full force and effect.
                </p>
              </section>

              <section className="mb-5">
                <h2>16. Entire Agreement</h2>
                <p>
                  These Terms, together with the Privacy Policy, Refund Policy,
                  and any other legal notices published on the Platform,
                  constitute the entire agreement between you and the Company
                  regarding the use of the Platform and Services, superseding
                  any prior agreements or understandings.
                </p>
              </section>

              <section className="mb-5">
                <h2>17. Contact Us</h2>
                <p>
                  If you have any questions, concerns, or grievances regarding
                  these Terms or the Platform, you may contact us at:
                </p>
                <address>
                  <strong>PANMITRA ONLINE SERVICE PRIVATE LIMITED</strong>
                  <br />
                  Belagavi, Karnataka - 590015, India
                  <br />
                  Phone: +91 9632-456-111
                  <br />
                  Email: panmitra121@gmail.com
                  <br />
                  Web: https://instantpanmitra.com
                </address>
                <p className="mt-3">
                  <strong>Grievance Officer:</strong> For any complaints or
                  grievances, please email us at grievance@instantpanmitra.com.
                  The Grievance Officer shall acknowledge the complaint within
                  48 hours and resolve it within 30 days as per applicable laws.
                </p>
              </section>

              <div className="text-center mt-5">
                <p className="mt-3 text-muted">
                  By using our Platform or Services, you confirm that you have
                  read, understood, and unconditionally agree to these Terms &
                  Conditions.
                </p>
              </div>
            </div>
          </div>
        </main>
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default TermsConditions;
